import { render } from "./MailboxIcon.vue?vue&type=template&id=4a27c92f"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MailboxIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a27c92f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a27c92f', __exports__)) {
    api.reload('4a27c92f', __exports__)
  }
  
  module.hot.accept("./MailboxIcon.vue?vue&type=template&id=4a27c92f", () => {
    api.rerender('4a27c92f', render)
  })

}


export default __exports__